import React from 'react';
import {connect} from 'react-redux';
import {Redirect, useLocation} from 'react-router-dom';
import {isUserAuthenticated, logout} from '../../utils/auth';

/***
 * HOC that handles authorizing a user to a specific page.
 *
 * https://medium.com/better-programming/role-based-authorization-in-react-c70bb7641db4
 * @param allowedRoles
 * @returns {function(*): *}
 */
export default (allowedRoles = []) => WrappedComponent => {
    function Authorization(props) {
        const {auth} = props;
        const location = useLocation();

        const isAuthorized = isUserAuthenticated(auth.token);
        if (!isAuthorized) {
            logout();
        }

        const {role} = auth; // TODO add roles permission check

        const {pathname} = location;

        switch (pathname) {
        case '/login':
            return (isAuthorized) ?
                <Redirect to="/"/> :
                <WrappedComponent {...props}/>;
        default:
            return (!isAuthorized) ?
                <Redirect to="/login"/> :
                <WrappedComponent {...props}/>;
        }
    }

    const mapStateToProps = state => ({auth: state.auth});
    return connect(mapStateToProps)(Authorization);
};
